/** @jsxImportSource @emotion/react */
import React, { FC } from 'react';
import * as styles from './SparkleLoader.styles';
import { Constants } from 'global';

type SparkleLoaderProps = {
  message?: string;
};

export const SparkleLoader: FC<SparkleLoaderProps> = ({
  message = 'Loading...',
}) => {
  return (
    <div css={styles.sparkleContainer}>
      <img
        src={Constants.assets.signUpAssets.icons.sparkleLoader}
        alt="Loading..."
      />
      <p className="body4" css={styles.sparkleLoaderMessage}>
        {message}
      </p>
    </div>
  );
};
